export const INSTAGRAM_URL = 'https://instagram.com/silicontrades';
